import * as React from 'react';
import styled from 'styled-components';
import { borderRadius, boxShadow, color, flex, height, space, width, themeGet } from 'styled-system';
import { ThemeInterface } from '../../theme/ThemeInterface';
import { Label, Span } from '../../typography';
import Box from '../primitives/Box';
import { StyledSystemProps } from '../../theme/StyledSystemProps';
import { FieldProps, ErrorMessage } from 'formik';

type Props = StyledSystemProps & {
  bg?: string;
  name?: string;
  type?: string;
  maxLength?: number;
  color?: string;
  width?: string;
  height?: string;
  boxShadow?: string;
  children?: React.ReactNode;
  borderRadius?: string | number;
  id?: string;
  label?: string;
  placeholder?: string;
  mr?: number;
  disabled?: boolean;
};

const StyledTextArea = styled.textarea`
  ${flex};
  ${space};
  ${width};
  ${color};
  ${height};
  ${boxShadow};
  ${borderRadius};
  padding: 10px;
  display: flex;
  position: relative;
  background-color: ${themeGet('colors.paleGrey', '#eee')};
  width: 100%;
  min-height: 150px;
  box-sizing: border-box;
  border-radius: 4px;
  border: 1px solid rgba(50, 50, 93, 0.2);
  font-size: ${(props: ThemeInterface) => props.theme.fontSizes[0]};
  &:disabled {
    color: hsl(0,0%,60%);
  }
`;

const TextArea: React.FC<FieldProps & Props> = props => {
  const [charactersLeft, setCharactersLeft] = React.useState(props.maxLength!) 
  return (
    <Box width="100%" {...props}>
      <Label htmlFor={props.field.name}>{props.label}</Label>
      <StyledTextArea disabled={props.disabled} placeholder={props.label} {...props.field} onChange={(e) => {
         setCharactersLeft(props.maxLength! - e.target.value.length);
      }} />
      { charactersLeft < props.maxLength! && charactersLeft >= 0
          && <Label textAlign="right">{ charactersLeft} characters left</Label> }
      <ErrorMessage name={props.field.name} >
        {msg => {
          return (
            <Span mt={1} color="error" textAlign="right">
              {msg}
            </Span>
          );
        }}
      </ErrorMessage>
    </Box>
  );
};

export default TextArea;

TextArea.defaultProps = {
  width: '100%',
  height: '150px',
  mb: 5,
  flex: 1,
  maxLength: 1024
};



// WEBPACK FOOTER //
// ./src/components/formElements/StyledTextArea.tsx